var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ConfirmationDialog2", { ref: "confirmationDialog" }),
      _vm._v(" "),
      _vm._t("default", null, { submit: _vm.submit, loading: _vm.loading }),
      _vm._v(" "),
      _c("ExecutionResultsDialog", {
        ref: "executionResultsDialog",
        on: {
          close: function ($event) {
            return _vm.$emit("reload")
          },
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function ({ isError }) {
              return [
                isError
                  ? _c(
                      "span",
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-1",
                            attrs: { large: "", color: "error" },
                          },
                          [_vm._v("error")]
                        ),
                        _vm._v("\n        Failed to ingest the file\n      "),
                      ],
                      1
                    )
                  : _c(
                      "span",
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "mr-1",
                            attrs: { large: "", color: "success" },
                          },
                          [_vm._v("check_circle")]
                        ),
                        _vm._v("\n        Successfully ingested file\n      "),
                      ],
                      1
                    ),
              ]
            },
          },
          {
            key: "actions",
            fn: function ({ FileResults }) {
              return [
                FileResults && FileResults.length == 1
                  ? _c("ul", [
                      _c(
                        "li",
                        { staticClass: "pb-2" },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "dataset",
                                  params: { id: FileResults[0].FileId },
                                },
                                target: "_blank",
                              },
                            },
                            [_vm._v("Review the\n            file")]
                          ),
                          _vm._v(
                            " and its contents for any formatting mistakes. Reupload the file if any changes were\n          made.\n        "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isTenantAdmin
                        ? _c("li", { staticClass: "pb-2" }, [
                            _vm._v(
                              "Customize the ingestion service configurations to better suit your file\n          format."
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isTenantAdmin
                        ? _c(
                            "li",
                            { staticClass: "pb-2" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "dataset",
                                      params: { id: FileResults[0].FileId },
                                    },
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    "Manually set the\n            file type"
                                  ),
                                ]
                              ),
                              _vm._v(" by editing the file.\n        "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("li", { staticClass: "pb-2" }, [
                        _vm._v(
                          "Contact your administrator or Hatfield if you require assistance."
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                FileResults && FileResults.length > 1
                  ? _c("ul", [
                      _c("li", { staticClass: "pb-2" }, [
                        _vm._v(
                          "\n          Review the files and their contents for any formatting mistakes.\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isTenantAdmin
                        ? _c("li", { staticClass: "pb-2" }, [
                            _vm._v(
                              "Customize the ingestion service configurations to better suit your file\n          formats."
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isTenantAdmin
                        ? _c("li", { staticClass: "pb-2" }, [
                            _vm._v(
                              "\n          Manually set the file types by editing the files directly.\n        "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("li", { staticClass: "pb-2" }, [
                        _vm._v(
                          "Contact your administrator or Hatfield if you require assistance."
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "next",
            fn: function ({ FileResults }) {
              return [
                FileResults.length == 1
                  ? _c(
                      "PrimaryBtn",
                      {
                        attrs: {
                          icon: "event_note",
                          color: "primary",
                          to: {
                            name: "allimports",
                            query: { search: FileResults[0].ReingestionId },
                          },
                        },
                      },
                      [_vm._v("View ingestion summary\n      ")]
                    )
                  : FileResults.length > 1
                  ? _c(
                      "PrimaryBtn",
                      {
                        attrs: { icon: "event_note", color: "primary" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.goToImport(FileResults[0])
                          },
                        },
                      },
                      [_vm._v("View ingestion summary")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                FileResults.length == 1 &&
                FileResults[0].ServiceName != "A125 Ingestion Service"
                  ? _c(
                      "PrimaryBtn",
                      {
                        attrs: {
                          icon: "pending_actions",
                          color: "primary",
                          to: {
                            name: "reviewingestionresults",
                            params: {
                              executionId: FileResults[0].ReingestionId,
                            },
                          },
                        },
                      },
                      [_vm._v("Review\n        ingestion")]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }